var React = require('react');

function AudioSolid (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"noun_Audio_2524823","transform":"translate(-5 -4.001)"},React.createElement("g",{"id":"Group_119","data-name":"Group 119","transform":"translate(5 4.001)"},React.createElement("path",{"id":"Path_58","data-name":"Path 58","d":"M19.964,5V27a1.022,1.022,0,0,1-.6.907,1.1,1.1,0,0,1-.442.093,1,1,0,0,1-.645-.237L11.487,22H7.449A2.462,2.462,0,0,1,5,19.5v-7A2.462,2.462,0,0,1,7.449,10h4.038l6.8-5.763A1.023,1.023,0,0,1,19.964,5Zm1.629,7.606a1,1,0,0,0-.446,1.342,5.111,5.111,0,0,1,0,4.105,1,1,0,1,0,1.785.895,7.121,7.121,0,0,0,0-5.895,1,1,0,0,0-1.339-.447Zm4.118-2.553a1,1,0,1,0-1.785.895,12.383,12.383,0,0,1,0,10.105,1,1,0,1,0,1.785.895A14.365,14.365,0,0,0,25.711,10.053Z","transform":"translate(-5 -4.001)","fill":"#fff"}))));
}

AudioSolid.defaultProps = {"width":"22","height":"23.999","viewBox":"0 0 22 23.999"};

module.exports = AudioSolid;

AudioSolid.default = AudioSolid;
